import { NgModule } from "@angular/core";
import { RegistrationTaxInterestRateService } from "./registration-tax-interest-rate.service";

@NgModule({
  providers: [RegistrationTaxInterestRateService],
})
export class SettingsServicesModule {}
